
import React, { useState, useContext, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { AuctionsContext } from '../../contexts/AuctionsProvider'

const VehicleWatchList = () =>
{
	const navigate = useNavigate()
	const auctionsContext = useContext(AuctionsContext)
	
	useEffect(() =>
	{
		setupWatchlistView()
	}, [])
	
	const setupWatchlistView = () =>
	{
		auctionsContext.setMemberSearchRequest((previousSearchRequest) =>
		{
			const currentSearchRequest = { ...previousSearchRequest }
			currentSearchRequest.viewWatchlist = true
			
			return currentSearchRequest
		})
		navigate('/secure/dealer-auction-listing', { state: { viewWatchlist: true } })
	}
	
	return (
		<>
		</>
	)
}

export default VehicleWatchList
